/**
 * Formats a date to the uniform format: "13 Feb" or "13 Feb, 2026" (if different year)
 * @param {string|Date} dateString - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "N/A";
  
  const currentYear = new Date().getFullYear();
  const dateYear = date.getFullYear();
  
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  
  const day = date.getDate();
  const month = months[date.getMonth()];
  
  if (dateYear === currentYear) {
    return `${day} ${month}`;
  } else {
    return `${day} ${month}, ${dateYear}`;
  }
};

/**
 * Formats a timestamp to include time: "13 Feb, 10:30 UTC" or "13 Feb, 2026, 10:30 UTC"
 * @param {string|Date} dateString - The timestamp to format
 * @returns {string} Formatted timestamp string
 */
export const formatDateTime = (dateString) => {
  if (!dateString) return "N/A";
  
  // Handle microseconds in ISO string
  const isoString = dateString.toString();
  const cleanedIso = isoString.replace(/\.\d+Z$/, "Z");
  const date = new Date(cleanedIso);
  
  if (isNaN(date.getTime())) return "N/A";
  
  const currentYear = new Date().getFullYear();
  const dateYear = date.getFullYear();
  
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  
  const day = date.getDate();
  const month = months[date.getMonth()];
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  
  const datepart = dateYear === currentYear ? `${day} ${month}` : `${day} ${month}, ${dateYear}`;
  return `${datepart}, ${hours}:${minutes} UTC`;
};

/**
 * Formats a date for PDF reports - always includes year: "13 Feb, 2025"
 * @param {string|Date} dateString - The date to format
 * @returns {string} Formatted date string with year
 */
export const formatDateForPDF = (dateString) => {
  if (!dateString) return "N/A";
  
  // Handle microseconds in ISO string
  const isoString = dateString.toString();
  const cleanedIso = isoString.replace(/\.\d+Z$/, "Z");
  const date = new Date(cleanedIso);
  
  if (isNaN(date.getTime())) return "N/A";
  
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  
  return `${day} ${month}, ${year}`;
};